import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {UserService} from './user/user.service';
import {AlertService} from './alert/alert.service';

@Injectable()
export class ReqInterceptorService implements HttpInterceptor {

  constructor(private router: Router, private us: UserService, private alert: AlertService) {
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const matches = req.url.match(/authenticate|login|(user\/forgetPassword)/);
    if (matches && matches.length > 0) {
      return next.handle(req);
    }

    const token = localStorage.getItem('token');
    if (!token) {
      this.router.navigate(['/login']);
      return;
    }
    const newReq = req.clone({
      setHeaders: {Authorization: `Bearer ${token}`}
    });
    return next.handle(newReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status !== 401) {
          // this.refreshToken();
          // this.alert.showToast('error','Authorization error!')
          if (err.status == 423) {
            this.alert.closeAlert()
            this.alert.toast('error',err.error.message)
            this.alert.lockNotifier.next(true)
            return EMPTY
          }
          return throwError(err);
        }
        this.alert.closeAlert()
        localStorage.clear();
        this.router.navigate(['/login'], {queryParams: {token: 'invalid'}, skipLocationChange: true});
        return EMPTY

      })
    );
  }

  async refreshToken() {
    const data = await this.us.login({
      refresh_token: localStorage.getItem('refresh_token'),
      grant_type: 'refresh_token'
    }).toPromise();
  }
}
